import React from 'react';
import { Box, Container, useMediaQuery, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { GoogleAuthService } from '../services/GoogleAuthService';
import { router } from '@inertiajs/react';
import BrandingSection from '../components/BrandingSection';

const AppLoginPage: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: '#FFFA66',
          minHeight: '100vh',
          width: '100vw',
          margin: 0,
          padding: isMobile ? 4 : 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: isMobile ? 'flex-start' : 'center',
          boxSizing: 'border-box',
          overflowX: 'hidden'
        }}
      >
        <Container
          maxWidth={false}
          disableGutters={true}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'center',
            textAlign: isMobile ? 'left' : 'center',
            width: '100%',
            maxWidth: isMobile ? '100%' : '600px',
          }}
        >
          <BrandingSection animatedTaglines={true}>
            <GoogleSignInButton
              googleCallback={(response) =>
                GoogleAuthService.handleGoogleResponse(response, () => router.visit('/home'))}
            />
          </BrandingSection>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default AppLoginPage;